import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcShare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.25 19.243v-5a.75.75 0 0 1 1.5 0v5c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25v-5a.75.75 0 0 1 1.5 0v5a1.75 1.75 0 0 1-1.75 1.75H5a1.75 1.75 0 0 1-1.75-1.75m8-2.243V5.81L8.53 8.53a.75.75 0 1 1-1.06-1.06l4-4 .056-.052a.75.75 0 0 1 1.004.052l4 4a.75.75 0 1 1-1.06 1.06l-2.72-2.72V17a.75.75 0 0 1-1.5 0"
  }));
}
var IcShare = createNolIcon(/*#__PURE__*/forwardRef(SvgIcShare));

export { IcShare as I };
